import React from 'react';

/**
 * IpsScanSummary
 *
 * Live summary bar showing how many clients are queued, currently scanning,
 * found to have an IPS document, missing one, or errored. Status tiles are
 * multi-select: click any combination to filter the table, and click Total
 * to clear all status filters.
 */
const IpsScanSummary = ({ counts, activeStatuses = [], onStatusToggle, onClearFilters, scannedAt }) => {
  const stats = [
    { key: null, label: 'Total', value: counts.total, colClass: '', textClass: '' },
    { key: 'queued', label: 'Queued', value: counts.queued, colClass: '', textClass: 'text-secondary' },
    { key: 'scanning', label: 'Scanning', value: counts.scanning, colClass: 'border-primary', textClass: 'text-primary' },
    { key: 'found', label: 'IPS Found', value: counts.found, colClass: 'border-success', textClass: 'text-success' },
    { key: 'missing', label: 'No Match', value: counts.missing, colClass: 'border-danger', textClass: 'text-danger' },
    { key: 'reason:no_alignment', label: 'No Alignment', value: counts.noAlignment, colClass: 'border-danger', textClass: 'text-danger' },
    { key: 'reason:inactive_client', label: 'Inactive Client', value: counts.inactiveClient, colClass: 'border-danger', textClass: 'text-danger' },
    { key: 'error', label: 'Errors', value: counts.error, colClass: 'border-warning', textClass: 'text-warning-emphasis' },
  ];

  return (
    <div className="row g-3 mb-3">
      {stats.map((stat) => {
        const isTotal = stat.key === null;
        const isActive = isTotal
          ? activeStatuses.length === 0
          : activeStatuses.includes(stat.key);

        return (
          <div className="col-6 col-md-3 col-lg" key={stat.label}>
            <button
              type="button"
              className={`card text-center w-100 border-0 ${stat.colClass} ${isActive ? 'shadow-sm border' : ''}`}
              onClick={() => (isTotal ? onClearFilters() : onStatusToggle(stat.key))}
            >
              <div className="card-body py-2">
                <div className="text-muted small">{stat.label}</div>
                <div className={`fs-4 fw-bold ${stat.textClass}`}>{stat.value}</div>
              </div>
            </button>
          </div>
        );
      })}
      {scannedAt && (
        <div className="col-12">
          <div className="text-muted small">
            Last completed: {new Date(scannedAt).toLocaleString()}
          </div>
        </div>
      )}
    </div>
  );
};

export default IpsScanSummary;

